/**
 * Dotted-path read/write over the rate-card draft.
 *
 * The schema addresses every fee by a path like `afs.bands.0.1`, so the editor
 * never needs to know the shape of the card it is editing. `setIn` clones each
 * node on the way down, so React always sees a new object and the draft is
 * never mutated in place.
 */

export const getIn = (source, path) =>
  String(path)
    .split(".")
    .reduce((node, key) => (node === null || node === undefined ? undefined : node[key]), source);

export const setIn = (source, path, value) => {
  const keys = String(path).split(".");
  const clone = Array.isArray(source) ? [...source] : { ...source };
  let node = clone;
  keys.slice(0, -1).forEach((key) => {
    const next = node[key];
    node[key] = Array.isArray(next) ? [...next] : { ...(next || {}) };
    node = node[key];
  });
  node[keys[keys.length - 1]] = value;
  return clone;
};
